module.exports = __webpack_public_path__ + "img/15.2b2fca39.jpg";